/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import {
  WorkflowStatusService,
  SqdStatusState,
  TrayStatus,
} from '../services/workflow-status.service';
import { JobsModalComponent } from './modals/jobs-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  trigger,
  transition,
  animate,
  state,
  style,
  group,
  query,
  animateChild,
} from '@angular/animations';
import { UserService } from '../services/user.service';
import { GuestJobsModalComponent } from './modals/guest-jobs-modal.component';

@Component({
  selector: 'status-tray',
  templateUrl: './status-tray.component.html',
  styleUrls: ['./status-tray.component.less'],
  animations: [
    trigger('parentAnimation', [
      state('in', style({ height: '*', opacity: 0 })),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        group([
          query('@childAnimation', [animateChild()]),
          animate(500, style({ height: 0 })),
          animate('500ms 500ms ease-in-out', style({ opacity: '0' })),
        ]),
      ]),
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        group([
          query('@childAnimation', [animateChild()]),
          animate(500, style({ height: '*' })),
          animate('500ms ease-in-out', style({ opacity: '1' })),
        ]),
      ]),
    ]),
    trigger('childAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms 700ms ease-in'),
      ]),
      transition(':leave', animate('500ms ease-out', style({ opacity: 0 }))),
    ]),
  ],
  standalone: false,
})
export class StatusTrayComponent implements OnInit {
  display = false;
  currentStatus: TrayStatus;
  statusStates: typeof SqdStatusState = SqdStatusState;
  jobModalOpened: boolean;

  constructor(
    private workflowStatusService: WorkflowStatusService,
    private modalService: NgbModal,
    private userService: UserService,
  ) {}

  ngOnInit() {
    // subscribe receives the value.
    this.workflowStatusService.trayStatusChange.subscribe(
      (data: TrayStatus) => {
        if (this.userService.isGuestUser) {
          this.display = false;
          this.viewGuestDetails();
        } else {
          if (data.processingWorkflows) {
            this.currentStatus = data;
            this.display = this.userService.isLoggedOn();
          } else {
            this.display = false;
          }
        }
      },
    );
  }

  showProcessedStatus() {
    return (
      this.currentStatus.erroredStates ||
      this.currentStatus.waitingStates ||
      this.currentStatus.completedStates
    );
  }

  viewDetails() {
    if (!this.jobModalOpened) {
      this.jobModalOpened = true;
      const modalRef = this.modalService.open(JobsModalComponent, {
        windowClass: 'xrx-modal',
      });
      modalRef.result.catch(() => {
        this.jobModalOpened = false;
      });
    }
  }

  viewGuestDetails() {
    if (!this.jobModalOpened) {
      this.jobModalOpened = true;
      const modalRef = this.modalService.open(GuestJobsModalComponent, {
        windowClass: 'xrx-modal',
        backdrop: 'static',
      });
      modalRef.result.catch(() => {
        this.workflowStatusService.guestLogoutAndClose();
        this.jobModalOpened = false;
      });
    }
  }
}
